import { useSearchParams } from "react-router-dom";
import { Boxes, ClipboardList, MapPin, PackageCheck } from "lucide-react";
import { useAuth, useCan } from "@/context/AuthContext";
import { NoAccess } from "@/components/NoAccess";
import Grns from "@/components/inventory/Grns";
import PutAway from "@/components/inventory/PutAway";
import StockView from "@/components/inventory/StockView";
import Locations from "@/components/inventory/Locations";

const TABS = [
  ["receiving", "Goods Receiving", ClipboardList, Grns],
  ["putaway", "Put-away", PackageCheck, PutAway],
  ["stock", "Stock by location", Boxes, StockView],
  ["locations", "Locations", MapPin, Locations],
];

export default function Inventory() {
  const { session } = useAuth();
  const can = useCan();
  const [sp, setSp] = useSearchParams();
  if (!session.business.inventory_entitled || !session.business.inventory_on || !can("receive")) return <NoAccess what="Inventory" />;
  const tab = TABS.find((t) => t[0] === sp.get("tab")) || TABS[0];
  const Body = tab[3];
  return (
    <div className="h-full overflow-y-auto" data-testid="inventory-page">
      <div className="mx-auto max-w-6xl px-4 py-6 sm:px-8">
        <div className="eyebrow">Inventory · {session.branch.name}</div>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-slate-900">Goods & shelves</h1>
        <div className="mt-5 flex gap-1 overflow-x-auto rounded-xl bg-slate-100 p-1" role="tablist">
          {TABS.map(([id, label, Icon]) => (
            <button key={id} role="tab" aria-selected={tab[0] === id} onClick={() => setSp({ tab: id })} data-testid={`inventory-tab-${id}`}
              className={`flex h-10 shrink-0 items-center gap-1.5 rounded-lg px-3.5 text-sm font-bold transition-colors ${tab[0] === id ? "bg-slate-950 text-white" : "text-slate-600 hover:text-slate-950"}`}>
              <Icon className="h-4 w-4" />{label}
            </button>
          ))}
        </div>
        <div className="mt-6"><Body key={session.branch.id} /></div>
      </div>
    </div>
  );
}
